import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Progress({ value, max = 100, tone, indeterminate, label, className, style, ...rest }) {
    const clamped = value === undefined ? undefined : Math.max(0, Math.min(max, value));
    // The fill width is data, not a design decision: the CSS contract owns how the
    // value renders; the wrapper only feeds it through the custom property.
    const fillStyle = clamped === undefined
        ? style
        : { ...style, "--fwfa-progress-value": `${(clamped / max) * 100}%` };
    return (_jsx("div", { className: cn("fwfa-progress", indeterminate && "fwfa-progress--indeterminate", className), "data-tone": tone, role: "progressbar", "aria-label": label, "aria-valuemin": 0, "aria-valuemax": max, "aria-valuenow": indeterminate ? undefined : clamped, style: fillStyle, ...rest, children: _jsx("div", { className: "fwfa-progress-fill" }) }));
}
//# sourceMappingURL=Progress.js.map